import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  Button,
  Grid,
  Header,
  Segment,
  Icon,
  Card,
  Image,
  Message,
} from "semantic-ui-react";

class AcceptStepPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentImageSrc: this.getBookCover(props.docReq.document, props.docReq),
    };

    this._isMounted = false;
    this._timeouts = [];
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
    // Clear all pending timeouts
    this._timeouts.forEach((timeoutId) => {
      clearTimeout(timeoutId);
    });
    this._timeouts = [];
  }

  removeTimeout = (timeoutId) => {
    const index = this._timeouts.indexOf(timeoutId);
    if (index > -1) {
      this._timeouts.splice(index, 1);
    }
  };

  getPlaceholderUrl = () => {
    const backendUrl = process.env.REACT_APP_INVENIO_UI_URL;
    return `${backendUrl}/static/images/placeholder.png`;
  };

  handleImageError = (e, document) => {
    e.persist();
    const imageElement = e.target;
    const placeholderUrl = this.getPlaceholderUrl();

    // If already using placeholder, stop retrying
    if (this.state.currentImageSrc === placeholderUrl) {
      return;
    }

    // Directly use placeholder after first failure
    if (this._isMounted) {
      this.setState({
        currentImageSrc: placeholderUrl,
      });

      const timeoutId = setTimeout(() => {
        if (this._isMounted) {
          this.removeTimeout(timeoutId);
          if (imageElement) {
            imageElement.src = placeholderUrl;
          }
        }
      }, 100);

      this._timeouts.push(timeoutId);
    }
  };

  // handleImageLoad = () => {
  //   // No state update needed here
  // };

  handleAccept = () => {
    const { acceptRequest, docReq } = this.props;
    if (acceptRequest && docReq.pid) {
      acceptRequest(docReq.pid);
    }
  };

  handleDecline = () => {
    const { declineRequest, docReq } = this.props;
    if (declineRequest && docReq.pid) {
      declineRequest(docReq.pid);
    }
  };

  getBookCover = (document, docReq) => {
    const placeholderUrl = this.getPlaceholderUrl();

    if (!document) return placeholderUrl;

    // Try cover metadata URLs
    const coverMetadata = document.cover_metadata;
    if (coverMetadata?.urls) {
      const coverUrl =
        coverMetadata.urls.medium ||
        coverMetadata.urls.large ||
        coverMetadata.urls.small;

      if (coverUrl?.trim()) return coverUrl;
    }

    // Try document PID endpoint
    if (document.pid) {
      return `/api/literature/${document.pid}/cover`;
    }

    return placeholderUrl;
  };

  getAuthorNames = (authors) => {
    if (!authors) return "No authors available";
    if (typeof authors === "string") return authors;

    if (Array.isArray(authors)) {
      const authorNames = authors
        .map((author) => {
          if (typeof author === "object" && author.full_name)
            return author.full_name;
          if (typeof author === "string") return author;
          return "";
        })
        .filter((name) => name.trim())
        .join(", ");

      return authorNames || "No authors available";
    }

    if (typeof authors === "object" && authors.full_name) {
      return authors.full_name;
    }

    return "No authors available";
  };

  renderBookInfo = (
    displayTitle,
    displayAuthors,
    displayYear,
    bookInfo,
    documentPid,
    docReq
  ) => (
    <>
      <Card.Header style={{ fontSize: "1.2em", marginBottom: "10px" }}>
        <Icon name="book" />
        {displayTitle}
      </Card.Header>

      <Card.Meta style={{ marginBottom: "8px" }}>
        <Icon name="users" />
        <strong>Authors:</strong> {displayAuthors}
      </Card.Meta>

      {bookInfo.publisher && (
        <Card.Meta style={{ marginBottom: "8px" }}>
          <Icon name="building" />
          <strong>Publisher:</strong> {bookInfo.publisher}
        </Card.Meta>
      )}

      {docReq.edition && (
        <Card.Meta style={{ marginBottom: "8px" }}>
          <Icon name="book" />
          <strong>Edition:</strong> {docReq.edition}
        </Card.Meta>
      )}

      {displayYear && (
        <Card.Meta style={{ marginBottom: "8px" }}>
          <Icon name="calendar" />
          <strong>Year:</strong> {displayYear}
        </Card.Meta>
      )}

      {(docReq.isbn || docReq.issn || docReq.standard_number) && (
        <Card.Meta style={{ marginBottom: "8px" }}>
          <Icon name="barcode" />
          <strong>Identifier:</strong>{" "}
          {docReq.isbn || docReq.issn || docReq.standard_number}
        </Card.Meta>
      )}

      <Card.Meta style={{ marginBottom: "8px" }}>
        <Icon name="hashtag" />
        <strong>Document ID:</strong> {documentPid || "Not assigned"}
      </Card.Meta>

      {docReq.medium && (
        <Card.Meta style={{ marginBottom: "8px" }}>
          <Icon name="file" />
          <strong>Format:</strong> {docReq.medium}
        </Card.Meta>
      )}

      {docReq.request_type && (
        <Card.Meta style={{ marginBottom: "8px" }}>
          <Icon name="tag" />
          <strong>Request Type:</strong> {docReq.request_type}
        </Card.Meta>
      )}

      {docReq.copies_needed && (
        <Card.Meta style={{ marginBottom: "8px" }}>
          <Icon name="copy" />
          <strong>Copies Needed:</strong> {docReq.copies_needed}
        </Card.Meta>
      )}

      {docReq.note && (
        <Card.Meta>
          <Icon name="comment" />
          <strong>User Note:</strong> {docReq.note}
        </Card.Meta>
      )}
    </>
  );

  renderCover = (document) => {
    const coverImage = this.state.currentImageSrc;

    return (
      <div
        style={{
          width: "200px",
          height: "280px",
          border: "1px solid #ddd",
          borderRadius: "8px",
          overflow: "hidden",
          backgroundColor: "#f5f5f5",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginLeft: "220px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <Image
          src={coverImage}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
          onError={(e) => this.handleImageError(e, document)}
          // onLoad={this.handleImageLoad}
        />
      </div>
    );
  };

  renderBookCard = () => {
    const { docReq } = this.props;
    const { document_pid: documentPid, title, authors, document } = docReq;

    // Prioritize user-submitted information over document information
    const userAuthorNames = this.getAuthorNames(authors);
    const documentAuthorNames = document?.authors
      ? this.getAuthorNames(document.authors)
      : null;

    // Use user-submitted data first, fallback to document data
    const displayTitle = title || document?.title || "No title available";
    const displayAuthors =
      userAuthorNames !== "No authors available"
        ? userAuthorNames
        : documentAuthorNames || "No authors available";

    // For other fields, prioritize user input
    const displayYear =
      docReq.publication_year || document?.publication_year || null;
    const displayPublisher = docReq.publisher || document?.publisher || null;

    return (
      <Card fluid>
        <Card.Content>
          <Grid>
            <Grid.Row>
              <Grid.Column width={4}>
                <div style={{ textAlign: "center" }}>
                  {this.renderCover(document)}
                </div>
              </Grid.Column>
              <Grid.Column width={12}>
                <div
                  style={{
                    textAlign: "left",
                    marginLeft: "270px",
                    marginTop: "60px",
                  }}
                >
                  {this.renderBookInfo(
                    displayTitle,
                    displayAuthors,
                    displayYear,
                    { publisher: displayPublisher },
                    documentPid,
                    docReq
                  )}
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card.Content>
      </Card>
    );
  };

  renderSimpleBookInfo = () => {
    const { docReq } = this.props;
    const { title, authors } = docReq;

    const displayTitle = title || "No title available";
    const displayAuthors = this.getAuthorNames(authors);

    return (
      <Card fluid>
        <Card.Content>
          <Grid>
            <Grid.Row>
              <Grid.Column width={4}>
                <div style={{ textAlign: "center" }}>
                  <div
                    style={{
                      width: "150px",
                      height: "200px",
                      backgroundColor: "#f5f5f5",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto",
                    }}
                  >
                    <Icon name="image outline" size="large" color="grey" />
                  </div>
                </div>
              </Grid.Column>
              <Grid.Column width={12}>
                <Card.Header
                  style={{ fontSize: "1.2em", marginBottom: "10px" }}
                >
                  <Icon name="book" />
                  {displayTitle}
                </Card.Header>
                <Card.Meta style={{ marginBottom: "8px" }}>
                  <Icon name="users" />
                  <strong>Authors:</strong> {displayAuthors}
                </Card.Meta>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card.Content>
      </Card>
    );
  };

  render() {
    const { docReq } = this.props;
    const { document_pid: documentPid } = docReq;

    // Check if request is not pending (i.e., has been accepted or declined)
    const isPending = docReq.state === "PENDING";
    const isAccepted = docReq.state === "ACCEPTED";

    return (
      <div>
        <Header as="h3">
          <Icon name="handshake outline" />
          <Header.Content>
            Accept Request
            <Header.Subheader style={{ color: "black" }}>
              Review the request details and accept or decline
            </Header.Subheader>
          </Header.Content>
        </Header>

        <Segment>
          {/* Show message if request has been accepted */}
          {isAccepted && (
            <Message positive size="small">
              <Message.Header>Request Accepted</Message.Header>
              <p>The request has been accepted successfully.</p>
            </Message>
          )}

          {/* Show message if request is not pending */}
          {!isPending && !isAccepted && (
            <Message size="small">
              <Message.Header>Request Completed</Message.Header>
              <p>
                The request has been completed and can no longer be modified.
              </p>
            </Message>
          )}

          <Grid>
            <Grid.Row>
              <Grid.Column width={16}>
                <Header as="h4">
                  <Icon name="clipboard list" />
                  Summary of Book Request
                </Header>
                {documentPid ? (
                  this.renderBookCard()
                ) : (
                  <div>
                    <Segment placeholder>
                      <Header icon>
                        <Icon name="search" />
                        No document selected
                      </Header>
                      <p>
                        Please select a document for this request to see
                        detailed information.
                      </p>
                    </Segment>
                    {this.renderSimpleBookInfo()}
                  </div>
                )}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={16}>
                <div style={{ marginTop: "20px" }}>
                  <Button
                    positive
                    icon="check"
                    labelPosition="left"
                    content="Accept Request"
                    size="large"
                    disabled={!isPending}
                    onClick={this.handleAccept}
                  />
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </div>
    );
  }
}

AcceptStepPanel.propTypes = {
  docReq: PropTypes.object.isRequired,
  acceptRequest: PropTypes.func.isRequired,
  declineRequest: PropTypes.func,
};

AcceptStepPanel.defaultProps = {
  declineRequest: null,
};

export default AcceptStepPanel;
